import fetch from "lib/fetch";
import type { ScholarLevelInterface } from "types/reference";

type ScholarLevelListResponse = { data: Array<ScholarLevelInterface> };

export const getScholarLevelsRequest = (languageCode: string) =>
    fetch.get<ScholarLevelListResponse>(`reference/scholar_level/${languageCode}`);
